var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        /* jshint esversion: 6 */
        /* jshint strict: false */
        /* global app */

        // Same-tab history traversal cannot carry new query parameters. Consume once at the target.
        window.markHotelSearchBack = function (target) {
            if (!/\/hotels\/[^/]+\/[^/]+\/[^/]+/.test(window.location.pathname)) {
                return;
            }
            try {
                var url = new URL(target, window.location.origin);
                if (url.origin !== window.location.origin || !/\/(?:new\/)?find-tours\/?$/.test(url.pathname)) {
                    return;
                }
                sessionStorage.setItem('search_attribution_back', JSON.stringify({
                    target: url.href,
                    created: Date.now(),
                    parent: window.__searchAnalyticsContext ? window.__searchAnalyticsContext.search_attempt_id : ''
                }));
            } catch (_) {/* Storage may be disabled. Navigation must still work. */}
        };

        var NavBar = function () {
            function NavBar() {
                _classCallCheck(this, NavBar);

                this.backUrl = app.backUrl;
                this.eventDispatcher = window.eventDispatcher;
                this.initHandlers();
            }

            _createClass(NavBar, [{
                key: "initHandlers",
                value: function initHandlers() {
                    var _this = this;

                    this.eventDispatcher.addEvent('click', '#back-button', function (event) {
                        return _this.handleBackClick(event);
                    });
                }
            }, {
                key: "handleBackClick",
                value: function handleBackClick(event) {
                    if (event) {
                        event.preventDefault();
                    }

                    var beforeBackEvent = new CustomEvent('nav-bar:before-back', {
                        cancelable: true,
                        detail: {
                            backUrl: this.backUrl,
                            referrer: document.referrer
                        }
                    });

                    window.dispatchEvent(beforeBackEvent);

                    if (beforeBackEvent.defaultPrevented) {
                        if (event) {
                            event.preventDefault();
                            event.stopPropagation();
                        }

                        return;
                    }

                    if (document.referrer) {
                        try {
                            var referrerUrl = new URL(document.referrer);

                            if (referrerUrl.hostname === location.hostname) {
                                if (window.history.length > 1) {
                                    window.markHotelSearchBack(document.referrer);
                                    window.history.back();
                                    return;
                                }

                                window.markHotelSearchBack(document.referrer);
                                window.location.href = document.referrer;
                                return;
                            }
                        } catch (error) {
                            // Ignore invalid referrer and fallback to backUrl.
                        }
                    }

                    window.markHotelSearchBack(app.backUrl);
                    window.location.href = app.backUrl;
                }
            }]);

            return NavBar;
        }();

        // Инициализация


        new NavBar();
    }, {}] }, {}, [1]);